import type { Table } from '@tanstack/react-table'
import type { DataTableInstance, DataTableRowData } from 'blocks/cx-data-table/types'
import { DataTableFilterAdapter } from 'blocks/data-table/data-table-faceted-filter'
import { CrossIcon } from 'lucide-react'
import { Button } from 'primitives/button'

interface Props<TData extends DataTableRowData> {
  table: DataTableInstance<TData>
}

export const ClientSideFilter = <TData extends DataTableRowData>({ table }: Props<TData>) => {
  const {
    options: { filterFields = [] },
  } = table

  const isFiltered = table.getState().columnFilters.length > 0
  const data = table.getPreFilteredRowModel().rows.map((row) => row.original)
  return (
    <div className="flex flex-row gap-4">
      {filterFields.length > 0 && (
        <DataTableFilterAdapter
          table={table as unknown as Table<TData>}
          filterFields={filterFields}
          data={data}
          strategy="client"
        />
      )}
      {isFiltered && (
        <Button
          aria-label="Reset filters"
          variant="ghost"
          className="h-8 px-2 lg:px-3"
          onClick={() => table.resetColumnFilters()}
        >
          Reset
          <CrossIcon className="ml-2 size-4" aria-hidden="true" />
        </Button>
      )}
    </div>
  )
}
